import { useCallback } from "react"
import { useNavigate } from "react-router-dom"

import { useAppDispatch } from "store/hooks"
import { setInitialURL } from "store/tempDataSlise"
import { setUserProfile } from "store/userSlise"
import { StorageKeys } from "types/enums/StorageKeys"

import { clearStorage, getStorageItem, setStorageItem } from "utils/localStorage"

export const useLogout = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const logout = useCallback(() => {
    navigate("/auth/sign-in")
    dispatch(setUserProfile(null))
    dispatch(setInitialURL(undefined))
    sessionStorage.clear()
    const userTemperatureScale = getStorageItem(StorageKeys.UserTemperatureScale)
    const userActiveTheme = getStorageItem(StorageKeys.UserTheme)
    const userLogo = getStorageItem(StorageKeys.UserLogo)
    const enabledFeatureFlags = getStorageItem(StorageKeys.EnabledFeatureFlags)
    clearStorage()

    if (userTemperatureScale) {
      setStorageItem(StorageKeys.UserTemperatureScale, userTemperatureScale)
    }
    if (userActiveTheme) {
      setStorageItem(StorageKeys.UserTheme, userActiveTheme)
    }
    if (userLogo) {
      setStorageItem(StorageKeys.UserLogo, userLogo)
    }
    if (enabledFeatureFlags) {
      setStorageItem(StorageKeys.EnabledFeatureFlags, enabledFeatureFlags)
    }
    window.location.reload()
  }, [navigate, dispatch])

  return logout
}
